import { useQuery } from '@apollo/client'
import { BookkeepersManagementBookkeeperCompaniesDocument } from 'generated/resources/graphql'

import { useBookkeeperView } from 'modules/bookkeepers/lib/bookkeeperViewContext'

const useGetBookkeeperCompanies = () => {
  const isBookkeeperView = useBookkeeperView()

  const { loading, data } = useQuery(BookkeepersManagementBookkeeperCompaniesDocument, {
    context: {
      isBookkeeperView,
    },
    variables: {
      active: true,
    },
  })

  return {
    loading,
    bookkeeperCompanies: data?.bookkeepersManagement?.bookkeeperCompaniesConnection?.nodes,
  }
}

export default useGetBookkeeperCompanies
